export default function (num: Float32Array, size = 5){
    if(!num) return '-';
    let s = num+"";
    while (s.length < size) s = "0" + s;
    return s;
}